<template>
  <v-container fluid class="container-page">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        class="d-flex text-title-container"
      >
        <div class="text-title text-primary m-r-24">Reports</div>
      </v-col>

      <div
        class="expand-filter"
        :style="expandFilter ? widthExpand1 : widthExpand2"
      >
        <div v-if="expandFilter" class="border1">
          <div
            class="border1-container"
            :class="isCalendarShow ? 'hide-scroll-y1' : ''"
          >
            <v-tooltip :max-width="350" right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="icon-expand-filter"
                  @click="expandFilter = !expandFilter"
                  v-bind="attrs"
                  v-on="on"
                  >fas fa-angle-left</v-icon
                >
              </template>
              <span>Collapse filter</span>
            </v-tooltip>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-select
                  id="report"
                  class="box-select"
                  item-text="name"
                  item-value="value"
                  v-model="reportName"
                  :items="reports"
                  label="Report"
                  dense
                  hide-details
                  @change="reportChange"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <VueCtkDateTimePicker
                  v-model="search.from"
                  :max-date="search.to"
                  :format="
                    showDateOnly ? $dateFormatDefault : $datetimeFormatDefault
                  "
                  :no-value-to-custom-elem="true"
                  :no-button-now="true"
                  :only-date="showDateOnly"
                  @is-hidden="dataChange()"
                  @is-shown="setBorderStyle()"
                >
                  <v-text-field
                    class="font-size-body"
                    v-model="dateFrom"
                    prepend-inner-icon="mdi-calendar small"
                    :label="labelDateFrom"
                    readonly
                    dense
                    hide-details
                  ></v-text-field>
                </VueCtkDateTimePicker>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <VueCtkDateTimePicker
                  v-model="search.to"
                  :min-date="search.from"
                  :format="
                    showDateOnly ? $dateFormatDefault : $datetimeFormatDefault
                  "
                  :no-value-to-custom-elem="true"
                  :no-button-now="true"
                  :only-date="showDateOnly"
                  @is-hidden="dataChange()"
                  @is-shown="setBorderStyle()"
                >
                  <v-text-field
                    class="font-size-body"
                    v-model="dateTo"
                    prepend-inner-icon="mdi-calendar small"
                    :label="labelDateTo"
                    readonly
                    dense
                    hide-details
                  ></v-text-field>
                </VueCtkDateTimePicker>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('direction')"
              >
                <v-select
                  id="select-call-status"
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.direction"
                  :items="directionList"
                  label="Direction"
                  hide-details
                  @change="dataChange"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('channel_type')"
              >
                <v-select
                  id="select-call-status"
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.channelType"
                  :items="channelTypeList"
                  label="Channel type"
                  hide-details
                  @change="dataChange"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('channel')"
              >
                <v-combobox
                  v-model="channelSelected"
                  :items="channels"
                  item-value="value"
                  item-text="label"
                  hide-selected
                  label="Channel"
                  @change="dataChange"
                  dense
                  hide-details
                >
                  <template v-slot:selection="{ attrs, item }">
                    <div class="d-flex align-center">
                      <v-icon
                        v-if="item.icon"
                        :class="item.class"
                        class="m-r-5"
                      >
                        {{ item.icon }}
                      </v-icon>
                      <v-avatar v-if="item.img" size="20" class="m-r-5">
                        <img :src="item.img" :alt="item.label" />
                      </v-avatar>
                      {{ item.label ? item.label : channelSelected }}
                    </div>
                  </template>
                  <template v-slot:item="{ index, item }">
                    <v-list-item-content class="list-icon">
                      <div class="d-flex align-center">
                        <v-icon
                          v-if="item.icon"
                          :class="item.class"
                          class="m-r-5"
                        >
                          {{ item.icon }}
                        </v-icon>
                        <v-avatar v-if="item.img" size="22" class="m-r-5">
                          <img :src="item.img" :alt="item.label" />
                        </v-avatar>
                        {{ item.label }}
                      </div>
                    </v-list-item-content>
                  </template>
                </v-combobox>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('group_by')"
              >
                <v-select
                  id="select-date-format"
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.dateFormat"
                  :items="dateFormats"
                  label="Group by"
                  hide-details
                  @change="dataChange"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('destination')"
              >
                <v-combobox
                  id="select-last-service-status"
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="contactSelected"
                  :items="contacts"
                  label="Destination / Destination name"
                  hide-details
                  @change="dataChange"
                ></v-combobox>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('status')"
              >
                <v-select
                  id="select-call-status"
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.callStatus"
                  :items="callStatusList"
                  label="Status"
                  hide-details
                  @change="dataChange"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('last_service_type')"
              >
                <v-select
                  id="select-last-service-type"
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.lastServiceType"
                  :items="servicesTypeAll"
                  label="Last service type"
                  hide-details
                  @change="dataChange"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('last_service_status')"
              >
                <v-select
                  id="select-last-service-status"
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.lastServiceStatus"
                  :items="servicesStatus"
                  label="Last service result"
                  hide-details
                  @change="dataChange"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('service_type')"
              >
                <v-select
                  id="select-service-type"
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.serviceType"
                  :items="servicesType"
                  label="Service type"
                  hide-details
                  @change="dataChange"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('group_by_day_month')"
              >
                <v-select
                  id="select-date-format"
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.dateFormat"
                  :items="dateFormatsDayMonth"
                  label="Group by"
                  hide-details
                  @change="dataChange"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('gsbhd_group_by')"
              >
                <v-select
                  id="select-date-format"
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.dateFormat"
                  :items="dateFormatsForGsbhd"
                  label="รูปแบบการแสดงรายงาน"
                  hide-details
                  @change="dataChange"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('account_key')"
              >
                <v-text-field
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.accountKey"
                  label="Account key"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('file_name')"
              >
                <v-text-field
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.fileName"
                  label="File name"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="checkFilter('suppress_by')"
              >
                <v-select
                  class="box-select"
                  item-text="label"
                  item-value="value"
                  v-model="search.suppressBy"
                  :items="suppressBy"
                  label="Suppress by"
                  hide-details
                  @change="dataChange"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                class="d-flex justify-end"
              >
                <v-btn
                  id="btn-show-report"
                  class="btn-primary"
                  @click="getReport"
                  :disabled="!reportName"
                >
                  Run
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                class="d-flex p-t-0 p-b-0"
              >
                <div v-if="body2.length > 0">
                  <span class="font-size-body">Download as</span>
                  <!-- <v-icon x-large color="blue darken-3"
                >mdi-file-word-outline</v-icon
              > -->
                  <v-icon
                    class="icon-excel m-l-20"
                    color="green darken-1"
                    @click="genReport('excel')"
                    data-file="excel"
                  >
                    far fa-file-excel
                  </v-icon>
                  <v-icon
                    class="icon-excel m-l-10"
                    color="red lighten-1"
                    @click="genReport('pdf')"
                    data-file="excel"
                  >
                    far fa-file-pdf
                  </v-icon>
                  <!-- <v-icon
                x-large
                color="red darken-2"
                @click="genReport"
                data-file="pdf"
                >mdi-file-pdf-outline</v-icon
              > -->
                  <!-- <v-icon x-large @click="genReport" data-file="raw"
                >mdi-file-document-outline</v-icon
              > -->
                </div>
              </v-col>
            </v-row>
          </div>
          <div v-if="description" class="description">{{ description }}</div>
        </div>
        <div v-else class="border2">
          <v-tooltip :max-width="350" right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="icon-expand-filter"
                @click="expandFilter = !expandFilter"
                v-bind="attrs"
                v-on="on"
                >fas fa-angle-right</v-icon
              >
            </template>
            <span>Expand filter</span>
          </v-tooltip>
        </div>
      </div>

      <div
        class="container-report"
        :style="
          `${
            expandFilter ? widthCollapse1 : widthCollapse2
          } padding-right: 12px;`
        "
      >
        <v-data-table
          v-if="headers1.length"
          :loading="loading"
          :items="body2"
          :items-per-page="9999"
          hide-default-footer
          fixed-header
          :class="
            `${
              checkFilter('pagination') ? 'pagination-margin' : ''
            } elevation-1`
          "
        >
          <template v-slot:header>
            <thead class="v-data-table-header">
              <tr v-if="headers1.length !== 0">
                <th
                  v-for="head in headers1"
                  :class="head.align"
                  :style="head.style"
                  :rowspan="head.rowspan || ''"
                  :colspan="head.colspan || ''"
                  :key="head.value"
                >
                  <span v-if="head.tooltip">
                    <v-tooltip :max-width="350" top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ head.text }}</span>
                      </template>
                      <span><div v-html="head.tooltip"></div></span>
                    </v-tooltip>
                  </span>
                  <span v-else>{{ head.text }}</span>
                </th>
              </tr>
              <tr v-if="headers2.length !== 0">
                <th
                  v-for="head in headers2"
                  :class="head.align"
                  :style="head.style"
                  :rowspan="head.rowspan || ''"
                  :colspan="head.colspan || ''"
                  :key="head.value"
                >
                  <span v-if="head.tooltip">
                    <v-tooltip :max-width="350" top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ head.text }}</span>
                      </template>
                      <span><div v-html="head.tooltip"></div></span>
                    </v-tooltip>
                  </span>
                  <span v-else>{{ head.text }}</span>
                </th>
              </tr>
            </thead>
          </template>

          <template v-slot:item="props">
            <tr>
              <td
                v-for="(item, key) in props.item"
                :class="item.align"
                :rowspan="item.rowspan || ''"
                :colspan="item.colspan || ''"
                :style="item.style"
                :key="`${props.index}_${key}`"
              >
                <div v-if="item.type === 'percent'">
                  {{ item | reportNumberToPercent }}
                </div>
                <div v-else-if="item.type === 'number'">
                  {{ item | reportNumber1 }}
                </div>
                <div v-else-if="item.type === 'date'">
                  {{ item | reportDate }}
                </div>
                <div v-else>
                  {{ item.text }}
                </div>
              </td>
            </tr>
          </template>

          <template slot="body.append">
            <tr
              v-for="(item, index) in dataSum"
              class="font-weight-bold"
              :key="index"
            >
              <td
                v-for="(item1, key) in item"
                :class="
                  item1.align === 'text-right'
                    ? `${item1.align} cell-padding`
                    : item1.align
                "
                :style="item1.style"
                :colspan="item1.colspan || ''"
                :key="`${index}_${key}_sum`"
              >
                <div v-if="item1.type === 'percent'">
                  {{ item1 | reportNumberToPercent }}
                </div>
                <div v-else-if="item1.type === 'number'">
                  {{ item1 | reportNumber1 }}
                </div>
                <div v-else>
                  {{ item1.text }}
                </div>
              </td>
            </tr>
          </template>

          <template
            v-if="headers1.length !== 0 && body2.length === 0"
            v-slot:body
          >
            <tbody>
              <tr class="v-data-table__empty-wrapper">
                <td class="text-center" :colspan="totalColSpan">
                  No data available
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-row
          v-if="body2.length > 0 && checkFilter('pagination')"
          class="fix-height"
          align="center"
          justify="end"
        >
          <v-col
            class="d-flex align-center padding0 pagination"
            cols="auto"
            sm="auto"
            md="auto"
            lg="auto"
          >
            Page size
            <v-select
              id="perpage"
              class="select-item text-center m-l-10 m-r-10"
              v-model="search.limit"
              :items="$itemspage"
              item-text="title"
              item-value="value"
              no-label
              hide-details
              dense
              @input="search.limit = parseInt($event, 10)"
            ></v-select>
            Showing {{ (search.page - 1) * search.limit + 1 }} -
            {{ (search.page - 1) * search.limit + body2.length }} of
            {{ total | decimalFormat }}

            <v-pagination
              id="pagination"
              v-model="search.page"
              :length="totalPage"
              :total-visible="totalVisible"
            ></v-pagination>
          </v-col>
        </v-row>

        <div v-if="!headers1.length" class="border3"></div>
      </div>
      <!-- <v-col v-if="currentReport === 'session_report' && body2.length !== 0">
        <div class="red--text">หมายเหตุ :</div>
        <div class="red--text">Offload = Session - (Transfer + Error)</div>
        <div class="red--text">
          %Offload = (Session - (Transfer + Error))/Session
        </div>
      </v-col> -->
    </v-row>

    <dialog-export-loading
      v-if="dialogExportLoading"
      :dialogExportLoading="dialogExportLoading"
    />

    <dialog-export-confirm
      v-if="dialogConfirm.open"
      :dialogConfirm="dialogConfirm"
    />

    <snackbar v-if="snackbar.open" :snackbar="snackbar" />
  </v-container>
</template>

<script>
import _ from 'lodash'
import Moment from 'moment'

import variables from '@/styles/variables.scss'

import excelExporter from '@/services/report/excel'

import apiReport from '@/apis/report'
import apiContact from '@/apis/contact'

import Facebook from '@/assets/facebook.png'
import Line from '@/assets/line.png'

import DialogExportLoading from './components/dialog_export_loading'
import DialogExportConfirm from './components/dialog_export_confirm'

import Snackbar from './components/snackbar'

export default {
  components: {
    DialogExportLoading,
    DialogExportConfirm,
    Snackbar
  },
  data() {
    return {
      reports: [],
      settings: {},
      expandFilter: true,
      widthExpand1: 'width: 300px;',
      widthExpand2: 'width: 44px;',
      widthCollapse1: 'width: calc(100% - 310px);',
      widthCollapse2: 'width: calc(100% - 60px);',

      dateFormats: [
        {
          value: 'hour',
          label: 'Hour'
        },
        {
          value: 'day',
          label: 'Day'
        },
        {
          value: 'month',
          label: 'Month'
        },
        {
          value: 'year',
          label: 'Year'
        }
      ],
      dateFormatsDayMonth: [
        {
          value: 'day',
          label: 'Day'
        },
        {
          value: 'month',
          label: 'Month'
        }
      ],
      dateFormatsForGsbhd: [
        {
          value: 'day',
          label: 'วัน'
        },
        {
          value: 'month',
          label: 'เดือน'
        },
        {
          value: 'year',
          label: 'ปี'
        }
      ],
      directionList: [
        { label: '(All)', value: 'all' },
        { label: 'Inbound', value: 'inbound' },
        { label: 'Outbound', value: 'outbound' }
      ],
      channelTypeList: [
        { label: '(All)', value: 'all' },
        { label: 'Voice', value: 'voice' },
        { label: 'Chat', value: 'chat' }
      ],
      callStatusList: [
        { value: 'all', label: '(All)' },
        { value: 'ended by user', label: 'Ended by user' },
        { value: 'ended by system', label: 'Ended by system' },
        { value: 'transfer', label: 'Transfer' },
        { value: 'transfer hangup', label: 'Transfer hang up' },
        { value: 'transfer error', label: 'Transfer error' },
        { value: 'active', label: 'Active' },
        { value: 'timeout', label: 'Timeout' },
        { value: 'error', label: 'Error' }
      ],
      servicesTypeAll: [{ label: '(All)', value: 'all' }],
      servicesType: [{ label: '(All)', value: 'all' }],
      servicesStatus: [
        { value: 'all', label: '(All)' },
        { value: 'unknown', label: 'Incomplete' },
        { value: 'success', label: 'Success' },
        { value: 'fail', label: 'Failed' }
      ],
      channels: [{ value: 'all', label: '(All)' }],
      reportName: '',
      search: {
        from: '',
        to: '',
        page: 1,
        limit: 100,
        direction: 'all',
        channelType: 'all',
        channel: 'all',
        dateFormat: 'day',
        contact: 'all',
        callStatus: 'all',
        lastServiceType: 'all',
        lastServiceStatus: 'all',
        serviceType: 'all',
        accountKey: '',
        fileName: '',
        suppressBy: '(all)'
      },
      defaultSearch: {},
      total: 0,
      totalPage: 1,
      totalVisible: 7,
      contactSelected: '(All)',
      channelSelected: '(All)',
      reportFileName: '',
      format: 'YYYY-MM-DD HH:mm',
      loading: false,
      headers1: [],
      headers2: [],
      body2: [],
      dataSum: [],
      totalColSpan: '',

      objForExport: {},
      isCalendarShow: false,
      dialogExportLoading: {
        open: false,
        text: ''
      },
      dialogConfirm: {
        open: false,
        text: '',
        textBtn: ''
      },
      snackbar: {
        open: false,
        colorSnackbar: '',
        textSnackbar: ''
      },
      description: undefined,
      suppressBy: [
        { value: '(all)', label: '(All)' },
        { value: 'MAN', label: 'Manual' },
        { value: 'SYS', label: 'System' }
      ]
    }
  },
  created() {
    document.title = this.$t('page-title.report', {
      productName: this.$options.filters.getVariable('product_name')
    })

    this.defaultSearch = _.cloneDeep(this.search)

    this.search.from = Moment()
      .startOf('month')
      .format(this.format)
    this.search.to = Moment()
      .startOf('day')
      .add(1, 'days')
      .format(this.format)

    this.initial()

    // for (const property in this.search) {
    //   this.$watch(
    //     `search.${property}`, //what you want to watch
    //     (newVal, oldVal) => {
    //       this.getReport()
    //     }
    //   )
    // }
  },
  watch: {
    'search.limit': {
      handler() {
        if (this.checkFilter('pagination')) {
          this.search.page = 1
          this.getReport(true)
        }
      }
    },
    'search.page': {
      handler() {
        if (this.checkFilter('pagination')) {
          this.getReport(true)
        }
      }
    },
    'search.channelType': {
      handler() {
        this.getChannel()
      }
    }
  },
  computed: {
    showDateOnly() {
      if (
        ['suppressed_leads_report', 'suppressed_files_report'].includes(
          this.reportName
        )
      )
        return true

      return false
    },
    dateFrom() {
      if (
        ['suppressed_leads_report', 'suppressed_files_report'].includes(
          this.reportName
        )
      )
        return this.$options.filters.convertDatePicker(this.search.from)
      return this.$options.filters.convertDatetimePicker(this.search.from)
    },
    dateTo() {
      if (
        ['suppressed_leads_report', 'suppressed_files_report'].includes(
          this.reportName
        )
      )
        return this.$options.filters.convertDatePicker(this.search.to)
      return this.$options.filters.convertDatetimePicker(this.search.to)
    },
    labelDateFrom() {
      if (this.reportName === 'campaign_report') return 'Schedule from'
      else if (
        ['suppressed_leads_report', 'suppressed_files_report'].includes(
          this.reportName
        )
      )
        return 'Suppress start'
      return 'From'
    },
    labelDateTo() {
      if (this.reportName === 'campaign_report') return 'Schedule to'
      else if (
        ['suppressed_leads_report', 'suppressed_files_report'].includes(
          this.reportName
        )
      )
        return 'Suppress end'
      return 'To'
    }
  },
  methods: {
    async initial() {
      await this.getListReport()
      await this.getContact()
      await this.getChannel()
      await this.getServiceLogType()
    },
    async getListReport() {
      try {
        const getListReport = await apiReport.getListReport()
        const { data, settings } = getListReport

        this.reports = data
        this.settings = settings

        if (this.reports.length > 0) {
          const find = _.find(this.reports, { value: 'session_report' })
          if (find) {
            this.reportName = find.value
            this.reportChange('session_report')
          }
        }
      } catch (error) {}
    },
    async getContact() {
      try {
        const getContact = await apiContact.getContact({
          sortBy: ['name'],
          sortDesc: [false]
        })
        const { data } = getContact
        this.contacts = [{ value: 'all', label: '(All)' }]
        for (const obj of data) {
          this.contacts.push({
            value: obj.name,
            label: `${obj.name} (${obj.phone})`
          })
        }
      } catch {}
    },
    async getChannel() {
      try {
        const getChannel = await apiReport.getListChannel(
          this.search.channelType
        )
        const { data } = getChannel

        this.channels = [{ value: 'all', label: '(All)' }]

        for (const obj of data) {
          const list = {}

          list.value = obj._id
          list.label = obj.channel
          list.img = obj.img

          if (obj.platform === 'facebook') list.img = Facebook
          if (obj.platform === 'line') list.img = Line
          if (obj.platform === 'phone') {
            list.icon = 'mdi-phone-incoming'
            list.class = 'icon-voice-inbound'
          }

          this.channels.push(list)
        }
      } catch (error) {}
    },
    async getServiceLogType() {
      try {
        const getServiceLogType = await apiReport.getListServiceLogType()
        const { data } = getServiceLogType

        this.servicesTypeAll = this.servicesTypeAll.concat(data)
        this.servicesType = this.servicesType.concat(data)

        this.servicesType = _.filter(this.servicesType, o => {
          return o.value !== 'custom-service'
        })
      } catch {}
    },

    async getReport(changeLimit) {
      setTimeout(async () => {
        try {
          if (this.contactSelected) {
            if (this.contactSelected === '(All)') this.search.contact = 'all'
            else if (typeof this.contactSelected === 'string')
              this.search.contact = this.contactSelected
            else {
              const obj = _.find(this.contacts, {
                label: this.contactSelected.value
              })
              this.search.contact = obj ? obj.value : this.contactSelected.value
            }
          }
          if (this.channelSelected) {
            if (this.channelSelected === '(All)') this.search.channel = 'all'
            else if (typeof this.channelSelected === 'string')
              this.search.channel = this.channelSelected
            else {
              const obj = _.find(this.channels, {
                label: this.channelSelected.value
              })
              this.search.channel = obj ? obj.value : this.channelSelected.value
            }
          }

          if (this.reportName && this.search.dateFormat) {
            this.dialogExportLoading = {
              open: true,
              text: 'Loading...'
            }

            if (!changeLimit) {
              this.headers1 = []
              this.headers2 = []
              this.dataSum = []
            }

            if (changeLimit !== true) {
              this.search.page = 1
            }

            this.objForExport = _.cloneDeep(this.search)

            let getReport = await apiReport.getReport(
              this.reportName,
              this.objForExport
            )

            if (getReport) {
              const {
                headers1,
                headers2,
                body,
                dataSum,
                totalColSpan,
                totalPages,
                totalDocs
              } = getReport.data
              this.headers1 = headers1
              this.headers2 = headers2

              this.body2 = body

              this.dataSum = dataSum

              this.totalColSpan = totalColSpan

              this.totalPage = totalPages
              this.total = totalDocs || body.length
            }

            this.dialogExportLoading = {
              open: false,
              text: ''
            }
          }
        } catch (error) {
          this.dialogExportLoading = {
            open: false,
            text: ''
          }
        }
      }, 100)
    },

    async genReport(format) {
      try {
        const limitPerFile =
          parseInt(this.settings.report_records_per_file) || 50000
        const limitDownload =
          parseInt(this.settings.report_max_download_records) || 200000

        if (this.total > limitDownload) {
          this.dialogConfirm.open = true
          this.dialogConfirm.text = `Maximum of <b>${limitDownload.toLocaleString(
            'en-US'
          )}</b> records can be downloaded at a time.<br />Please reduce date rage of the report and try again.`
          this.dialogConfirm.textBtn = 'OK'
        } else {
          let titleLoading
          let fileType
          let ext
          if (format === 'excel') {
            titleLoading = 'Exporting Excel...'
            fileType = 'application/vnd.ms-excel'
            ext = 'xlsx'
          } else if (format === 'pdf') {
            titleLoading = 'Exporting PDF...'
            fileType = 'application/pdf'
            ext = 'pdf'
          }

          if (this.total > limitPerFile) {
            fileType = 'application/zip'
            ext = 'zip'
          }

          this.dialogExportLoading = {
            open: true,
            text: `${titleLoading}<br /><b>Do not close this window</b>`
          }
          setTimeout(async () => {
            let data
            let query
            if (format === 'excel') {
              query = {
                ...this.objForExport,
                total: this.total,
                color: {
                  primary: variables.primary,
                  primary_soft: variables.primarySoft,
                  text_color: variables.textColor
                },
                filter_label: this.filterLabel()
              }
              data = await apiReport.exportExcel(this.reportName, query)
            } else if (format === 'pdf') {
              const el = document.createElement('div')
              el.style = 'width: 1in;'
              document.body.appendChild(el)
              const dpi = el.offsetWidth
              document.body.removeChild(el)

              query = {
                ...this.objForExport,
                total: this.total,
                color: {
                  primary: variables.primary,
                  primary_soft: variables.primarySoft,
                  text_color: variables.textColor
                },
                filter_label: this.filterLabel(),
                dpi: dpi
              }
              data = await apiReport.exportPdf(this.reportName, query)
            }

            const blob = new Blob([data], { type: fileType })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)

            link.target = '_blank'
            link.download = `${this.reportFileName} - ${Moment(
              this.objForExport.from
            ).format('YYYY-MM-DD')} to ${Moment(this.objForExport.to).format(
              'YYYY-MM-DD'
            )}.${ext}`
            link.click()
            URL.revokeObjectURL(link.href)

            this.dialogExportLoading = {
              open: false,
              text: ''
            }
          }, 700)
        }
      } catch (err) {
        this.snackbar.colorSnackbar = 'error'
        this.snackbar.textSnackbar = err.message ? err.message : err
        this.snackbar.open = true

        this.dialogExportLoading = {
          open: false,
          text: ''
        }
      }
    },

    reportChange(value) {
      for (const property in this.defaultSearch) {
        if (!['from', 'to'].includes(property)) {
          this.search[property] = this.defaultSearch[property]
        }
      }

      this.headers1 = []
      this.headers2 = []
      this.body2 = []
      this.dataSum = []
      this.totalColSpan = ''

      const report = _.find(this.reports, { value: value })
      if (report) {
        // this.reportName = report.name
        this.reportFileName = report.name
        this.description = report.description
      }
    },
    setBorderStyle() {
      setTimeout(() => {
        this.isCalendarShow = true
      }, 10)
    },
    dataChange() {
      this.headers1 = []
      this.headers2 = []
      this.body2 = []
      this.dataSum = []
      this.totalColSpan = ''

      this.isCalendarShow = false
    },
    async enterContact(e) {
      this.contactSelected = e.target.value
    },
    checkFilter(value) {
      const obj = _.find(this.reports, { value: this.reportName })
      if (!obj) return false

      return obj['filter'] ? obj['filter'][value] : false
    },
    filterLabel() {
      const result = []

      const obj = _.find(this.reports, { value: this.reportName })
      if (obj && obj.filter) {
        // Direction
        if (obj.filter.direction) {
          const list = _.find(this.directionList, {
            value: this.search.direction
          })
          result.push(`Direction: ${list.label}`)
        }
        // Channel type
        if (obj.filter.channel_type) {
          const list = _.find(this.channelTypeList, {
            value: this.search.channelType
          })
          result.push(`Channel type: ${list.label}`)
        }
        // Channel
        if (obj.filter.channel) {
          const list = _.find(this.channels, {
            value: this.search.channel
          })
          result.push(`Channel: ${list ? list.label : this.search.channel}`)
        }
        // Group by
        if (obj.filter.group_by) {
          const list = _.find(this.dateFormats, {
            value: this.search.dateFormat
          })
          result.push(`Group by: ${list.label}`)
        }
        // Destination / Destination name
        if (obj.filter.destination) {
          const list = _.find(this.contacts, {
            value: this.search.contact
          })
          result.push(
            `Destination / Destination name: ${
              list ? list.label : this.search.contact
            }`
          )
        }
        // Status
        if (obj.filter.status) {
          const list = _.find(this.callStatusList, {
            value: this.search.callStatus
          })
          result.push(`Status: ${list.label}`)
        }
        // Last service type
        if (obj.filter.last_service_type) {
          const list = _.find(this.servicesTypeAll, {
            value: this.search.lastServiceType
          })
          result.push(`Last service type: ${list.label}`)
        }
        // Last service status
        if (obj.filter.last_service_status) {
          const list = _.find(this.servicesStatus, {
            value: this.search.lastServiceStatus
          })
          result.push(`Last service result: ${list.label}`)
        }
        // Service type
        if (obj.filter.service_type) {
          const list = _.find(this.servicesType, {
            value: this.search.serviceType
          })
          result.push(`Service type: ${list.label}`)
        }
        // Group by
        if (obj.filter.group_by_day_month) {
          const list = _.find(this.dateFormatsDayMonth, {
            value: this.search.dateFormat
          })
          result.push(`Group by: ${list.label}`)
        }
        // รูปแบบการแสดงรายงาน
        if (obj.filter.gsbhd_group_by) {
          const list = _.find(this.dateFormatsForGsbhd, {
            value: this.search.dateFormat
          })
          result.push(`รูปแบบการแสดงรายงาน: ${list.label}`)
        }

        if (obj.filter.account_key) {
          result.push(`Account key: ${this.search.accountKey || '(All)'}`)
        }
        if (obj.filter.file_name) {
          result.push(`File name: ${this.search.fileName}`)
        }
        if (obj.filter.suppress_by) {
          const list = _.find(this.suppressBy, {
            value: this.search.suppressBy
          })
          result.push(`Suppress by: ${list.label}`)
        }
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.container-page {
  height: 100%;
}

.border1 {
  position: relative;
  height: calc(100vh - 127px);
  // overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #c1c3d0;
  border-radius: 4px;
  // padding: 20px;

  // &.hide-scroll-y {
  //   overflow-y: unset;
  // }

  .border1-container {
    padding: 20px;
    // height: calc(100vh - 127px - 70px);
    height: calc(100vh - 145px);
    overflow-y: overlay;
    padding-bottom: 90px;

    &.hide-scroll-y1 {
      overflow-y: clip !important;
    }
  }
}

.border2 {
  position: relative;
  height: calc(100vh - 127px);
}

.border3 {
  position: relative;
  height: calc(100vh - 127px);
  background-color: #ffffff;
}

.expand-filter {
  padding-left: 12px;
  padding-right: 12px;
}
.icon-expand-filter {
  position: absolute;
  top: 10px;
  right: 10px;
}

.icon-excel {
  font-size: 25px;
}

::v-deep thead th {
  border: 1px solid #cdcfd4;
}

::v-deep tbody td {
  border: 1px solid #cdcfd4;
}

::v-deep .v-data-table__wrapper {
  height: calc(100vh - 130px);
}

::v-deep .pagination-margin .v-data-table__wrapper {
  height: calc(100vh - 170px);
}

::v-deep .v-data-table .v-data-table__wrapper td.text-right {
  padding-right: 16px !important;
}

::v-deep .container-report {
  height: calc(100vh - 130px);
}

.description {
  font-size: 0.9rem;
  position: absolute;
  bottom: -2px;
  padding: 10px 20px 10px 20px;
  background: white;
}
</style>
